import SimpleDocument from "./simple-document";

export default SimpleDocument;
